import React from "react";

const SaveIcon = ({ width = "14px", height = "14px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0327 2.15527C11.3844 2.16028 11.7199 2.30405 11.9661 2.55527L14.4994 5.08861C14.7506 5.33478 14.8944 5.67025 14.8994 6.02194V12.8219C14.8994 13.1756 14.7589 13.5147 14.5089 13.7647C14.2588 14.0148 13.9197 14.1553 13.5661 14.1553H4.23275C3.87913 14.1553 3.53999 14.0148 3.28994 13.7647C3.03989 13.5147 2.89941 13.1756 2.89941 12.8219V3.48861C2.89941 3.13498 3.03989 2.79585 3.28994 2.5458C3.53999 2.29575 3.87913 2.15527 4.23275 2.15527H11.0327Z"
        stroke="#FAFAFA"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2331 14.1556V9.48893C12.2331 9.31212 12.1628 9.14255 12.0378 9.01753C11.9128 8.8925 11.7432 8.82227 11.5664 8.82227H6.23307C6.05626 8.82227 5.88669 8.8925 5.76167 9.01753C5.63664 9.14255 5.56641 9.31212 5.56641 9.48893V14.1556"
        stroke="#FAFAFA"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.56641 2.15527V4.82194C5.56641 4.99875 5.63664 5.16832 5.76167 5.29334C5.88669 5.41837 6.05626 5.48861 6.23307 5.48861H10.8997"
        stroke="#FAFAFA"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SaveIcon;
